import React, { useState, useEffect, useRef } from "react";
import "./WikiSpeedrun.css";
import ModalBox from "../../components/ModalBox/ModalBox";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import ActivityHeader from "../../components/ActivityHeader/ActivityHeader";
import { initialModal } from "./Modals";
import wikiPages from "./WikiPages";
import { trackGameStart } from "../../utils/trackEvents";

export default function WikiSpeedrun() {
  const iframeRef = useRef(null);
  const [seconds, setSeconds] = useState(0);
  const [isStopped, setIsStopped] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [startPage, setStartPage] = useState("");
  const [targetPage, setTargetPage] = useState("");

  const pickRandomPages = () => {
    let s = "",
      t = "";
    while (s === t) {
      s = wikiPages[Math.floor(Math.random() * wikiPages.length)];
      t = wikiPages[Math.floor(Math.random() * wikiPages.length)];
    }
    setStartPage(s);
    setTargetPage(t);
  };

  useEffect(() => {
    pickRandomPages();
  }, []);

  useEffect(() => {
    if (isStopped) return;
    const id = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [isStopped]);

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSeconds(0);
    setIsStopped(false);
    iframeRef.current.src = `https://en.wikipedia.org/wiki/${startPage}`;
    trackGameStart("WikiSpeedrun", 1);
  };

  const handleButtonClick = () => {
    if (!isStopped) {
      setIsStopped(true);
    } else {
      pickRandomPages();
      setIsModalOpen(true);
    }
  };

  const formatTime = () =>
    seconds >= 3600
      ? `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m ${
          seconds % 60
        }s`
      : seconds >= 60
      ? `${Math.floor(seconds / 60)}m ${seconds % 60}s`
      : `${seconds}s`;

  return (
    <div className="wiki-speedrun-main">
      <ActivityHeader>
        <span>Target: {targetPage.replace(/_/g, " ")}</span>
        <span>{formatTime()}</span>
        <PrimaryButton
          onClick={handleButtonClick}
          type={isStopped ? "retry" : "stop"}
        >
          {isStopped ? "Retry" : "Stop"}
        </PrimaryButton>
      </ActivityHeader>
      <div className="wiki-speedrun-content">
        {startPage && (
          <iframe
            ref={iframeRef}
            src={`https://en.wikipedia.org/wiki/${startPage}`}
            title="Wiki iframe"
          />
        )}
      </div>
      <div className="wiki-speedrun-recognition">
        Content from Wikipedia, licensed under CC BY-SA 3.0 and GFDL.
      </div>
      <ModalBox
        isOpen={isModalOpen}
        {...initialModal(startPage, targetPage)}
        onClose={handleModalClose}
      />
    </div>
  );
}
